'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navigation = undefined;

var _reactCssThemr = require('react-css-themr');

var _identifiers = require('../identifiers');

var _Navigation = require('./Navigation');

var _button = require('../button');

var _link = require('../link');

var _theme = require('./theme.css');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemedNavigation = (0, _reactCssThemr.themr)(_identifiers.NAVIGATION, _theme2.default)((0, _Navigation.navigationFactory)(_button.Button, _link.Link));
exports.default = ThemedNavigation;
exports.Navigation = ThemedNavigation;


//////////////////
// WEBPACK FOOTER
// ./~/@luminopia/react-toolbox/lib/navigation/index.js
// module id = 674
// module chunks = 0